import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Treinamento } from '@/features/treinamento'

export const Route = createFileRoute('/_authenticated/treinamento/')({
  validateSearch: z.object({ modulo: z.string().optional() }),
  component: Treinamento,
})
